import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import * as actions from '../actions/sale';

const initialStats = {
  saleCodeList: {},
  taxingunitsui: {},
  sale: {
    data: {},
    state: null,
    finance: {},
    report: {},
    characteristics: {},
    ratio: {},
  },
  saleList: { data: [], state: null },
  salePropertyList: { data: [], state: null },
  fileList: { data: [], state: null },

  // sale search
  searchConfig: {
    data: [],
    state: null,
  },
  searchConfigResults: {
    data: [],
    state: null,
  },
  searchLastPayload: { data: {}, state: null },
  searchResult: {
    data: [],
    query: null,
    state: null,
  },
  searchParams: {
    data: [],
    state: null,
  },
  searchParam: {
    data: {},
    state: null,
  },
  searchFormData: {},
  saleSelectionData: {},
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 1000,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.SALES_FETCH_START: {
      return state
        .setIn(['saleList', 'data'], fromJS([]))
        .setIn(['saleList', 'state'], fetchingState.FETCHING);
    }
    case actions.SALES_FETCH_SUCCESS: {
      return state
        .setIn(['saleList', 'state'], fetchingState.LOADED)
        .setIn(['saleList', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.SALES_FETCH_ERROR: {
      return state.setIn(['saleList', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_DELETE_SUCCESS: {
      return state.setIn(
        ['saleList', 'data'],
        fromJS(
          state
            .getIn(['saleList', 'data'])
            .toJS()
            .filter(n => n.saleID !== action.saleID),
        ),
      );
    }

    case actions.SALE_CODES_FETCH_START: {
      return state.setIn(
        ['saleCodeList', action.codeType, action.name, 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.SALE_CODES_FETCH_SUCCESS: {
      return state
        .setIn(
          ['saleCodeList', action.codeType, action.name, 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['saleCodeList', action.codeType, action.name, 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SALE_CODES_FETCH_ERROR: {
      return state.setIn(
        ['saleCodeList', action.codeType, action.name, 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.SALE_UPDATE_SUCCESS: {
      return state
        .setIn(['sale', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }

    case actions.SALE_FETCH_START: {
      return state
        .setIn(['sale', 'data'], fromJS({}))
        .setIn(['sale', 'state'], fetchingState.FETCHING);
    }
    case actions.SALE_FETCH_SUCCESS:
    case actions.SET_SALE_DEED_SUCCESS:
    case actions.REMOVE_SALE_DEED_SUCCESS:
    case actions.POPULATE_SALE_SUCCESS: {
      return state
        .setIn(['sale', 'state'], fetchingState.LOADED)
        .setIn(['sale', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.SALE_FETCH_ERROR: {
      return state.setIn(['sale', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_CREATE_START: {
      return state.setIn(['sale', 'state'], fetchingState.SAVING);
    }
    case actions.SALE_CREATE_SUCCESS: {
      return state
        .setIn(['sale', 'state'], fetchingState.LOADED)
        .setIn(
          ['sale', 'data'],
          fromJS(_.get(action, 'data.results.sale[0]', {})),
        );
    }
    case actions.SALE_CREATE_ERROR: {
      return state.setIn(['sale', 'state'], fetchingState.ERROR);
    }

    case actions.RESET_SALE: {
      return state.setIn(['sale', 'data'], fromJS({}));
    }

    case actions.SET_CURRENT_SALE: {
      return state.setIn(
        ['sale', 'data'],
        fromJS(_.get(action, 'payload', {})),
      );
    }

    case actions.SALE_PROPERTIES_FETCH_START: {
      return state
        .setIn(['salePropertyList', 'data'], fromJS([]))
        .setIn(['salePropertyList', 'state'], fetchingState.FETCHING);
    }
    case actions.SALE_PROPERTIES_FETCH_SUCCESS: {
      return state
        .setIn(['salePropertyList', 'state'], fetchingState.LOADED)
        .setIn(
          ['salePropertyList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SALE_PROPERTIES_FETCH_ERROR: {
      return state.setIn(['salePropertyList', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_PROPERTY_DELETE_SUCCESS: {
      return state.setIn(
        ['salePropertyList', 'data'],
        fromJS(
          state
            .getIn(['salePropertyList', 'data'])
            .toJS()
            .filter(n => n.salePropertyID !== action.salePropertyID),
        ),
      );
    }

    case actions.FILES_FETCH_START: {
      return state.setIn(['fileList', 'state'], fetchingState.FETCHING);
    }
    case actions.FILES_FETCH_SUCCESS: {
      return state
        .setIn(['fileList', 'state'], fetchingState.LOADED)
        .setIn(
          ['fileList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachment', [])),
        );
    }
    case actions.FILES_FETCH_ERROR: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }

    case actions.FILE_CREATE_START:
    case actions.FILE_UPDATE_START: {
      return state.setIn(['fileList', 'state'], fetchingState.SAVING);
    }
    case actions.FILE_CREATE_SUCCESS:
    case actions.FILE_UPDATE_SUCCESS: {
      return state
        .setIn(['fileList', 'state'], fetchingState.LOADED)
        .setIn(
          ['fileList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachment', [])),
        );
    }
    case actions.FILE_CREATE_ERROR:
    case actions.FILE_UPDATE_ERROR: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }

    case actions.FILE_DELETE_START: {
      return state.setIn(['fileList', 'state'], fetchingState.SAVING);
    }
    case actions.FILE_DELETE_SUCCESS: {
      return state.setIn(['fileList', 'state'], fetchingState.LOADED).setIn(
        ['fileList', 'data'],
        fromJS(
          state
            .getIn(['fileList', 'data'])
            .toJS()
            .filter(document => document.s3ID !== action.s3ID),
        ),
      );
    }
    case actions.FILE_DELETE_ERROR: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_RATIO_FETCH_SUCCESS: {
      return state.setIn(
        ['sale', 'ratio'],
        fromJS(_.get(action, 'data.results.0', {})),
      );
    }

    case actions.SALE_FINANCE_FETCH_SUCCESS:
    case actions.SALE_FINANCE_UPDATE_SUCCESS: {
      return state.setIn(
        ['sale', 'finance'],
        fromJS(_.get(action, 'data.results.0', {})),
      );
    }

    case actions.SALE_REPORT_FETCH_SUCCESS:
    case actions.SALE_REPORT_UPDATE_SUCCESS: {
      return state.setIn(
        ['sale', 'report'],
        fromJS(_.get(action, 'data.results.0', {})),
      );
    }

    case actions.TAXING_UNITS_UI_FETCH_SUCCESS: {
      return state.setIn(
        ['taxingunitsui', action.uiType],
        fromJS(_.get(action, 'data.results', [])),
      );
    }

    case actions.SALE_CHARACTERISTICS_FETCH_SUCCESS:
    case actions.SALE_CHARACTERISTICS_UPDATE_SUCCESS: {
      return state.setIn(
        ['sale', 'characteristics'],
        fromJS(_.get(action, 'data.results.0', {})),
      );
    }

    // sale search
    case actions.SALE_SEARCH_CONFIG_FETCH_START: {
      return state.setIn(['searchConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.SALE_SEARCH_CONFIG_FETCH_SUCCESS: {
      return state
        .setIn(['searchConfig', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfig', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SALE_SEARCH_CONFIG_FETCH_ERROR: {
      return state.setIn(['searchConfig', 'state'], fetchingState.ERROR);
    }

    case actions.SEARCH_CONFIG_RESULTS_FETCH_START: {
      return state.setIn(
        ['searchConfigResults', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.SEARCH_CONFIG_RESULTS_FETCH_SUCCESS: {
      return state
        .setIn(['searchConfigResults', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchConfigResults', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SEARCH_CONFIG_RESULTS_FETCH_ERROR: {
      return state.setIn(['searchConfigResults', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_SEARCH_PARAMS_FETCH_START: {
      return state.setIn(['searchParams', 'state'], fetchingState.FETCHING);
    }
    case actions.SALE_SEARCH_PARAMS_FETCH_SUCCESS: {
      return state
        .setIn(['searchParams', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParams', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SALE_SEARCH_PARAMS_FETCH_ERROR: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_SEARCH_PARAM_FETCH_START: {
      return state.setIn(['searchParam', 'state'], fetchingState.FETCHING);
    }
    case actions.SALE_SEARCH_PARAM_FETCH_SUCCESS:
    case actions.SALE_SEARCH_PARAM_INSERT_SUCCESS:
    case actions.SALE_SEARCH_PARAM_UPDATE_SUCCESS: {
      return state
        .setIn(['searchParam', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParam', 'data'],
          fromJS(_.get(action, 'data.results.0', {})),
        );
    }
    case actions.SALE_SEARCH_PARAM_FETCH_ERROR: {
      return state.setIn(['searchParam', 'state'], fetchingState.ERROR);
    }

    case actions.SALE_SEARCH_PARAM_RESET: {
      return state
        .setIn(['searchParam', 'data'], fromJS({}))
        .setIn(['saleSelectionData'], fromJS({}));
    }

    case actions.SALE_SEARCH_PARAM_SET: {
      return state.setIn(
        ['searchParam', 'data'],
        fromJS(
          state
            .getIn(['searchParams', 'data'])
            .toJS()
            .find(v => v.searchParamID === action.searchParamID),
        ),
      );
    }

    case actions.SALES_SEARCH_START: {
      return state
        .setIn(['searchResult', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.SALES_SEARCH_SUCCESS: {
      return state
        .setIn(['searchResult', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchResult', 'query'],
          fromJS(_.get(action, 'data.query', [])),
        )
        .setIn(
          ['searchLastPayload', 'data'],
          fromJS(_.get(action, 'payload', {})),
        )
        .setIn(
          ['searchResult', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['pagination', 'count'],
          fromJS(_.get(action, 'data.totalProperty.saleCount', 0)),
        );
    }
    case actions.SALES_SEARCH_ERROR: {
      return state.setIn(['searchResult', 'state'], fetchingState.ERROR);
    }

    case actions.SET_SEARCH_FORM_DATA: {
      return state.setIn(['searchFormData'], fromJS(action.payload));
    }
    case actions.SET_SALE_SELECTION_DATA: {
      return state.setIn(['saleSelectionData'], fromJS(action.payload));
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }

    default: {
      return state;
    }
  }
};
